var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newMatch",class:_vm.getClass,on:{"click":_vm.saveNewMatch}},[_c('span',[_vm._v(" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }